<template>
  <legal-layout>
    <section class="legal-card legal-center">
      <h1 class="legal-title">
        {{ $t('legal.center') }}
      </h1>
      <p class="legal-lead">
        {{ $t('legal.centerIntro', { brand: info.brand }) }}
      </p>

      <div class="legal-center__grid">
        <section
          v-for="group in groups"
          :key="group.id"
          class="legal-center__group"
        >
          <h2 class="legal-center__heading">
            {{ group.title }}
          </h2>
          <ul>
            <li
              v-for="doc in group.docs"
              :key="doc.slug"
            >
              <router-link
                class="legal-center__link"
                :to="{ name: 'legal.document', params: { slug: doc.slug } }"
              >
                <span class="legal-center__icon">
                  <feather-icon
                    :icon="doc.icon"
                    size="18"
                  />
                </span>
                <span class="legal-center__label">{{ $t(`legal.docs.${doc.key}`) }}</span>
                <feather-icon
                  class="legal-center__chevron"
                  icon="ChevronRightIcon"
                  size="18"
                />
              </router-link>
            </li>
          </ul>
        </section>
      </div>

      <div class="legal-center__actions">
        <router-link
          class="legal-center__action"
          :to="{ name: 'legal.report', hash: '#illegal' }"
        >
          <feather-icon
            icon="AlertTriangleIcon"
            size="16"
          />
          {{ $t('legal.reportIllegal') }}
        </router-link>
        <a
          class="legal-center__action"
          :href="`mailto:${info.email}`"
        >
          <feather-icon
            icon="MailIcon"
            size="16"
          />
          {{ info.email }}
        </a>
      </div>

      <p class="legal-note">
        {{ $t('legal.operatedBy', { brand: info.brand, company: info.company }).replace('..', '.') }}
        <template v-if="$i18n.locale !== 'en'">
          {{ $t('legal.translationNote') }}
        </template>
      </p>
    </section>
  </legal-layout>
</template>

<script>
import { LEGAL_DOCS, LEGAL_INFO } from '@/libs/legal'
import LegalLayout from './LegalLayout.vue'

export default {
  name: 'LegalCenter',
  components: { LegalLayout },
  data() {
    return { info: LEGAL_INFO }
  },
  computed: {
    groups() {
      return [
        { id: 'agreements', title: this.$t('legal.agreements'), docs: LEGAL_DOCS.filter(d => d.group === 'agreements') },
        { id: 'safety', title: this.$t('legal.trust'), docs: LEGAL_DOCS.filter(d => d.group === 'safety') },
      ]
    },
  },
  watch: {
    '$i18n.locale': {
      immediate: true,
      handler() {
        document.title = `${this.$t('legal.center')} · ${this.info.brand}`
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.legal-center__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 28px;
  margin-top: 28px;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li + li {
    margin-top: 10px;
  }
}

.legal-center__heading {
  color: #fff !important;
  font-size: 13px;
  font-weight: 700;
  margin: 0 0 14px;
}

.legal-center__link {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border: 1px solid rgba(150, 110, 255, 0.22);
  border-radius: 14px;
  background: rgba(15, 8, 38, 0.45);
  color: #fff !important;
  font-weight: 600;
  text-decoration: none !important;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover,
  &:focus-visible {
    border-color: rgba(244, 114, 182, 0.6);
    background: rgba(15, 8, 38, 0.7);
  }
}

.legal-center__icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #7c3aed, #ea03b2);
  flex-shrink: 0;
}

.legal-center__label {
  flex: 1;
  min-width: 0;
}

.legal-center__chevron {
  opacity: 0.6;

  [dir='rtl'] & {
    transform: scaleX(-1);
  }
}

.legal-center__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 28px;
}

.legal-center__action {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 999px;
  border: 1px solid rgba(150, 110, 255, 0.3);
  color: #fff !important;
  font-size: 14px;
  text-decoration: none !important;
  word-break: break-all;

  &:hover {
    border-color: rgba(244, 114, 182, 0.6);
  }
}

@media (max-width: 767px) {
  .legal-center__grid {
    grid-template-columns: 1fr;
  }
}
</style>
